module.exports = __webpack_public_path__ + "img/cactusexpress.246fb83f.jpg";